import { useEffect, useRef } from 'react';
import '../styles/RichTextEditor.css';

const TOOLS = [
  { cmd: 'bold',        label: 'B',   title: 'Bold (Ctrl+B)',       style: { fontWeight: '700' } },
  { cmd: 'italic',      label: 'I',   title: 'Italic (Ctrl+I)',     style: { fontStyle: 'italic' } },
  { cmd: 'underline',   label: 'U',   title: 'Underline (Ctrl+U)',  style: { textDecoration: 'underline' } },
  { cmd: 'insertUnorderedList', label: '• List',  title: 'Bullet list' },
  { cmd: 'insertOrderedList',   label: '1. List', title: 'Numbered list' },
];

export default function RichTextEditor({ value, onChange, placeholder, rows = 4 }) {
  const editorRef = useRef(null);
  const isInternalChange = useRef(false);

  // Sync external value changes (e.g. form reset) into the editor
  useEffect(() => {
    const el = editorRef.current;
    if (!el || isInternalChange.current) return;
    if (el.innerHTML !== (value || '')) {
      el.innerHTML = value || '';
    }
  }, [value]);

  const handleInput = () => {
    isInternalChange.current = true;
    onChange(editorRef.current.innerHTML);
    isInternalChange.current = false;
  };

  const execCmd = (e, cmd) => {
    e.preventDefault(); // prevent losing focus
    document.execCommand(cmd, false, null);
    editorRef.current.focus();
    handleInput();
  };

  const isEmpty = !value || value === '<br>' || value === '';

  return (
    <div className="rte-wrapper">
      <div className="rte-toolbar">
        {TOOLS.map(({ cmd, label, title, style }) => (
          <button
            key={cmd}
            type="button"
            className="rte-btn"
            title={title}
            style={style}
            onMouseDown={(e) => execCmd(e, cmd)}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        ref={editorRef}
        className="rte-editor"
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        style={{ minHeight: `${rows * 1.6}em` }}
        data-placeholder={placeholder}
        aria-placeholder={placeholder}
      />
      {isEmpty && (
        <div className="rte-placeholder" onClick={() => editorRef.current.focus()}>
          {placeholder}
        </div>
      )}
    </div>
  );
}
